export const Success = 0;
export const Error = 1;
